"use client";

import { FormattedMessage } from "react-intl";
import type { PostSummary } from "@/lib/ressources";
import { PostCard } from "./PostCard";

export function RelatedArticles({
  posts,
  locale = "fr",
}: {
  posts: PostSummary[];
  locale?: "fr" | "en";
}) {
  if (posts.length === 0) return null;

  return (
    <section aria-labelledby="related-articles-title" className="mx-auto max-w-5xl px-6 py-16 2xl:max-w-6xl">
      <h2 id="related-articles-title" className="mb-6 text-2xl font-bold text-text-main 2xl:text-3xl">
        <FormattedMessage id="ressources.related.title" />
      </h2>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 2xl:gap-8">
        {posts.map((post) => (
          <PostCard key={`${post.category}-${post.slug}`} post={post} locale={locale} />
        ))}
      </div>
    </section>
  );
}
